import { render, staticRenderFns } from "./Fans.vue?vue&type=template&id=70e4407c&scoped=true"
import script from "./Fans.vue?vue&type=script&lang=js"
export * from "./Fans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e4407c",
  null
  
)

export default component.exports